import { api } from "../services/api";
import { CreateChatType, TimeLineDataType } from "../services/apiTypes";

export const getTimeLine = async (): Promise<TimeLineDataType[]> => {
  return api.get('media/timeline')
    .then(response => {
      if (response && response.status === 200 && response.data.length > 0) {
        return response.data;
      }
    })
    .catch(error => {
      console.log(error);
    });
};

export const createChatRoom = async (chat: CreateChatType): Promise<any> => {
  return api.post(`chat/rooms/create${chat.name}`, {
    receiverUserIds: chat.receiverUserIds,
    type: chat.type
  })
    .then(response => {
      console.log('createChatRoom', response.data);
      if (response && response.status === 201) {
        return response.data.id;
      }
    })
    .catch(error => {
      console.log(error);
    });
}

export const getChatRooms = async (): Promise<string[]> => {
  return api.get('chat/rooms')
    .then(response => {
      if (response && response.status === 200) {
        return response.data;
      }
    })
    .catch(error => {
      console.log(error);
    });
}

export const getChatRoomMessages = (chatId: string) => {
  api.get(`chat/rooms/${chatId}/messages`).then((response) => {
    if (response && response.status === 200) {
      return response.data;
    }
  }
  );
};